/**
 * The canonical catalog predicate for an AvailabilityRequest's stored site
 * filters. Keep this module pure and client-safe: the request form uses it to
 * render choices and the agency refresh planner uses it to reconcile a
 * full-selection request against proposed catalog facts.
 */
export function siteMatchesRequestFilters(site, request) {
  const typeMatches =
    request.siteType === "rv" || request.siteType === "tent"
      ? site.type.includes(request.siteType)
      : site.type === request.siteType;

  if (!typeMatches) return false;
  if (request.isTentOnly && site.type !== "tent") return false;

  if (
    request.maxRVLength != null &&
    (site.maxRVLength == null || site.maxRVLength < request.maxRVLength)
  ) {
    return false;
  }

  if (
    request.maxElectric != null &&
    (site.maxElectric == null || site.maxElectric < request.maxElectric)
  ) {
    return false;
  }

  for (const field of [
    "isPullThrough",
    "hasWater",
    "hasSewer",
    "hasElectric",
  ]) {
    if (request[field] && !site[field]) return false;
  }

  if (
    request.isDoubleSite != null &&
    site.isDoubleSite !== request.isDoubleSite
  ) {
    return false;
  }

  if (
    request.isAccessible != null &&
    site.isAccessible !== request.isAccessible
  ) {
    return false;
  }

  return true;
}
